import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Switch, FormControlLabel, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, Container, IconButton, RadioGroup, Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import SendIcon from '@material-ui/icons/Send';
import { Id } from 'react-flags-select';
import { handleCommentChange, handleInputChange, setInitialInputEnabled, setTest } from 'src/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import { setTask } from 'src/store/actions/taskActions';
import { connect } from 'react-redux';


const useStyles = makeStyles({
    container: {

    },
    formControlLabel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
        marginTop: '50px',
        justifyContent: 'space-evenly'
    },
    tableContainer: {
        width: 'auto',
    },
    button: {
        marginTop: '10px',
    },
    notes: {
        marginTop: '16px'
    },
    confirmButton: {
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'center',
    },
    createdBy: {
        marginTop: '16px',
    },
    gridContainer: {
        display: 'flex'
    },
    readOnlyInputs: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '16px',
    },
    readOnlyInputRow: {
        display: 'flex',
        alignItems: 'center',
    },
    readOnlyInput: {
        backgroundColor: '#fff',
        padding: '8px' // Örneğin, input alanlarının genişliğini ayarlamak için
    },
    radioGroup: {
        flexDirection: 'row',
        gap: '16px'
    }
});

const TestsComponent = ({
    testCriterias,
    readonly,
    tasks,
    ReceiptNo
}) => {
    const classes = useStyles();
    const inputEnabled = useSelector((state) => state.testReducer?.inputEnabled)
    const comment = useSelector((state) => state.testReducer?.comment)
    const dispatch = useDispatch();

    console.log(inputEnabled)


    const handleSwitchChange = (label) => {
        dispatch(setTest(label));
    };

    const handleTextChange = (e) => {
        let { name, value } = e.target;
        dispatch(handleInputChange(name, value, inputEnabled[name].value1));
    }

    const handleTextChange2 = (e) => {
        let { name, value } = e.target;
        dispatch(handleInputChange(name, inputEnabled[name].value, value));
    }

    const handleCommentOnChange = (e) => {
        let { value } = e.target;
        dispatch(handleCommentChange(value));

    }

    const handleRadioChange = (e) => {
        let { name, value } = e.target;
        dispatch(handleInputChange(name, inputEnabled[name]?.value, value));
    }

    useEffect(() => {
        if (testCriterias && testCriterias.length > 0) {
            let initialInputEnabled = {};
            if (Object.keys(inputEnabled).length === 0) {
                initialInputEnabled = testCriterias.reduce((acc, criteria) => {
                    acc[criteria.FieldText] = {
                        state: false,
                        id: criteria.Id,
                        value: '',
                        value1: '',
                        dataType: criteria.DataType,
                        productTestCriteriaId: criteria.ProductTestCriteriaId
                    }; // Default olarak tüm input alanları disabled olacak
                    return acc;
                }, {});
            }
            else {
                initialInputEnabled = inputEnabled;
            }
            dispatch(setInitialInputEnabled(initialInputEnabled));
        }
    }, [testCriterias]);


    useEffect(() => {
        const storeData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
        let transformedTestValues = storeData[0]?.Tests?.[0]?.TestValues;
        if (transformedTestValues) {
            let updatedTestValues = transformedTestValues.map(item => {
                // FieldText'i al
                let fieldText = item.fieldText;

                // Yeni objeyi oluştur ve FieldText'i yukarı taşı
                return {
                    [fieldText]: {
                        "fieldText": fieldText, // FieldText'i tekrar ekle
                        ...item // Diğer alanları koru
                    }
                };
            });

            let combinedObject = {};

            updatedTestValues.forEach(item => {
                let key = Object.keys(item)[0]; // Anahtarın adını al
                combinedObject[key] = item[key]; // Anahtar ve değeri yeni objeye ekle
            });

            dispatch(setInitialInputEnabled(combinedObject))
        }

        let testValuesComment = storeData[0]?.Tests?.[0]?.Comment;

        if (testValuesComment) {
            handleCommentOnChange({
                target: {
                    value: testValuesComment
                }
            });
        }

    }, [])


    const returnInputByLabel = (labelParam) => {
        const label = inputEnabled[labelParam];
        switch (label.dataType) {
            case 1:
                return (
                    <TableRow key={label.id}>
                        <TableCell>
                            <Box className={classes.readOnlyInputRow}>
                                <TextField
                                    variant="standard"
                                    fullWidth
                                    className={classes.readOnlyInput}
                                    placeholder=""
                                    InputProps={{
                                        readOnly: readonly ? readonly : !label.state,
                                        style: { backgroundColor: readonly || label.state ? 'white' : '#f0f0f0' }
                                    }}
                                    name={labelParam}
                                    onChange={(e) => handleTextChange(e)}
                                    value={label?.value}
                                />
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box className={classes.readOnlyInputRow}>
                                <TextField
                                    variant="standard"
                                    fullWidth
                                    className={classes.readOnlyInput}
                                    placeholder=""
                                    InputProps={{
                                        readOnly: readonly ? readonly : !label.state,
                                        style: { backgroundColor: readonly || label.state ? 'white' : '#f0f0f0' }
                                    }}
                                    name={labelParam}
                                    onChange={(e) => handleTextChange2(e)}
                                    value={label?.value1}
                                />
                            </Box>
                        </TableCell>
                    </TableRow>
                )
            case 2:
                return (
                    <TableRow key={label.id}>
                        <TableCell>
                            <Box className={classes.readOnlyInputRow}>
                                <RadioGroup value={label?.value1} name={labelParam} className={classes.radioGroup} onChange={handleRadioChange}>
                                    <FormControlLabel
                                        disabled={readonly ? readonly : !label.state}
                                        value="Pass"
                                        control={<Radio />}
                                        label="Pass" />
                                    <FormControlLabel disabled={readonly ? readonly : !label.state} value="Fail" control={<Radio />} label="Fail" />
                                </RadioGroup>
                            </Box>
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                )
            default:
                return null;
        }
    };


    return (
        <Box className={classes.container}>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item md={6} xs={12} className={classes.gridContainer}>
                        <Box className={classes.formControlLabel}>
                            {testCriterias.map((label) => (
                                <FormControlLabel
                                    key={label.Id}
                                    control={<Switch color="primary" onChange={() => handleSwitchChange(label)} />}
                                    label={label.FieldText}
                                    disabled={readonly}
                                    checked={inputEnabled[label.FieldText]?.state}
                                />
                            ))}
                        </Box>
                        <Box>
                            <TableContainer component={Paper} className={classes.tableContainer}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Earth Continuity</TableCell>
                                            <TableCell>Insulation Resistance</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Object.keys(inputEnabled).map((label) => (
                                            returnInputByLabel(label)
                                        ))}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Box className={classes.notes}>
                            <Typography variant="h6">Test Notes</Typography>
                            <TextField
                                multiline
                                rows={4}
                                fullWidth
                                variant="outlined"
                                placeholder="free text"
                                disabled={readonly}
                                onChange={(e) => handleCommentOnChange(e)}
                                value={comment}
                            />
                        </Box>
                    </Grid>
                </Grid>


                {/* <Box className={classes.confirmButton}>
                    <Button variant="contained" className={classes.button}>
                        CONFIRM
                    </Button>
                </Box> */}
            </Container>
        </Box>
    );
};



export default connect(
    (state) => ({
        tasks: state.tasks1
    })
)(TestsComponent);
